import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-163b62c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lifestyle" }
const _hoisted_2 = { class: "pics" }
const _hoisted_3 = { class: "pic" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dec" }, [
  /*#__PURE__*/_createTextVNode(" We integrate AI to support and enhance each pillar of lifestyle medicine, "),
  /*#__PURE__*/_createElementVNode("p", null, "ensuring comprehensive and personalised care")
], -1))

import { onMounted, reactive } from "vue";
import { store } from "@/utils/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileLifestyle',
  setup(__props) {

const pics = reactive<{
  pic: { url: string; title: string[] }[];
}>({
  pic: [],
});
onMounted(() => {
  if (localStorage.getItem("PAGE_MODEL_1")) {
    pics.pic = JSON.parse(localStorage.getItem("PAGE_MODEL_1") || "") || [];
  }
});

return (_ctx: any,_cache: any) => {
  const _component_ElCarousel_Item = _resolveComponent("ElCarousel-Item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_carousel, { "indicator-position": "outside" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pics.pic, (item) => {
            return (_openBlock(), _createBlock(_component_ElCarousel_Item, { key: item }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: item.url,
                    alt: ""
                  }, null, 8, _hoisted_4),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(item.title.join("")), 1)
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _hoisted_6
  ]))
}
}

})